import { ROLES } from "@components/Domain/Constants"
import { TYPE_ROLE, TYPE_HIDDEN } from "@components/Form"

import getAdditionalPermissionInputs from "./getAdditionalPermissionInputs"


const getCreateInputs = (isConsoleOrganization, updateSchema, organizationName) => {
  const additionalPermissionInputs = isConsoleOrganization
    ? []
    : getAdditionalPermissionInputs(organizationName)

  const rolesProps = isConsoleOrganization
    ? {
        name: "roles",
        type: TYPE_HIDDEN,
        initialValue: [ ROLES.ADMIN ],
      }
    : {
        name: "roles",
        type: TYPE_ROLE,
        label: "Select Role",
        inputProps: {
          onChange: () => updateSchema()
        }
      }

  return [
    rolesProps,
    ...additionalPermissionInputs,
    {
      name: "givenName",
      label: "First Name",
      itemProps: { style: { width: 270 } },
    },
    {
      name: "familyName",
      label: "Last Name",
      itemProps: { style: { width: 270 } },
    },
    {
      name: "email",
      itemProps: { style: { width: 270 } },
    },
    {
      name: "mobile",
    },
    {
      name: "sponsorId",
      type: TYPE_HIDDEN,
    },
  ]
}

export default getCreateInputs
